import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import NegativeSectionStore from './store';
// import Link from '@src/components/link';
import cx from 'classnames';

const styles = require('./index.less');

const NegativeSection = ({ store }) => {
  store.use();

  return (
    <div className={cx(styles.root, store.isActive && styles.rootActive)}>
      <iframe ref={store.negativeIframeRef} onLoad={store.onIframeLoad} title="xxx" src={store.src} width="100%" height="100%" frameBorder={0} border={0} />
    </div>
  );
};

export default wrapStore(NegativeSection, NegativeSectionStore);
